var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.06 7.09154L7.92668 3.52487C3.13502 1.12487 1.16835 3.09153 3.56835 7.8832L4.29335 9.3332C4.50168 9.7582 4.50168 10.2499 4.29335 10.6749L3.56835 12.1165C1.16835 16.9082 3.12668 18.8749 7.92668 16.4749L15.06 12.9082C18.26 11.3082 18.26 8.69153 15.06 7.09154ZM12.3684 10.6249H7.86835C7.52668 10.6249 7.24335 10.3415 7.24335 9.99987C7.24335 9.6582 7.52668 9.37487 7.86835 9.37487H12.3684C12.71 9.37487 12.9934 9.6582 12.9934 9.99987C12.9934 10.3415 12.71 10.6249 12.3684 10.6249Z",
    fill: "#E66F15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.9d410b368385a43852dbcd1d3f3be3f0.svg";
export { ForwardRef as ReactComponent };